import React, { useEffect, useState } from "react";
import { Form, Input, Modal, theme, Col, Row } from "antd";
import { POST, PATCH } from "../../../frameworks/HttpClient";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";

export default function AddTankModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]); 


  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        await PATCH(`${URL_SETTING.TANK}${target.id}/`, data);
      } else {
        await POST(URL_SETTING.TANK, data);
      }
      onUpdate();
    } catch (error) {
        setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขแทงก์น้ำยาง" : "เพิ่มแทงก์น้ำยาง"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      
      <Form form={form} layout="vertical">
        <Row gutter={10}>
          <Col span={24}>
          <Form.Item
            label="ชื่อแทงก์"
            name="name"
            rules={[{ required: true, message: "กรุณาระบุชื่อแทงก์" }]}
          >
            <Input placeholder="ชื่อแทงก์"/>
          </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="น้ำหนัก (Kg)/ ความสูง 1 cm"
              name="weight_per_height"
            >
              <Input placeholder="น้ำหนัก"/>
            </Form.Item>
            </Col>
            <Col span={12}>
            <Form.Item
              label="ลำดับการแสดง"
              name="display_seq"
              rules={[
                { required: true, message: "กรุณาระบุลำดับการแสดง" },
                { pattern: /^\d+$/, message: "กรุณาระบุเฉพาะตัวเลข" },
              ]}
            >
              <Input placeholder="ลำดับการแสดง" />
            </Form.Item>
            </Col>
          </Row>
      </Form>
    </Modal>
  );
}
